"use client";

import type { DatadogMetric } from "@/app/api/op/metrics";
import { fireAndForget } from "@/lib/vercelUtils";
import { postJson } from "@/utils/routeUtils";

export const trackSystemMetric = (metric: DatadogMetric) => {
  fireAndForget(postJson("/api/op", { metric }, { skipLogs: true }));
};

export const useSystemMetrics = () => {
  return { track: trackSystemMetric };
};
